import { Grid, Box, Text } from '@chakra-ui/react'
import { FC, useMemo, useEffect } from 'react'

import usePurchaseAlert from '@hook/alerts/use-purchase'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import LayoutTools from '@component/Layout/Tools'

import { validateAppVersion } from '@helper/util/storangeClear'
import generic from '@service/generic'

const PurchaseAlert: FC = () => {
  const { menuToggle } = useLayout()

  const { getFilters } = useFilters()
  const {
    loading,
    headers,
    actions,
    data,
    filename,
    params,
    setQuery,
    handleLocalParams,
    quantity,
    query,
    filters,
    setFilters,
    getData,
    filtersList,
    clearAllFilters,
    handleUpdateParams
  } = usePurchaseAlert()

  const { hasSessions } = useSessions()

  const height = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 30px)'
          : '100vh'
        : hasSessions
        ? 'calc(100vh - 160px)'
        : 'calc(100vh - 142px)',
    [menuToggle, hasSessions]
  )

  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 175px)'
          : 'calc(100vh - 144px)'
        : hasSessions
        ? 'calc(100vh - 316px)'
        : 'calc(100vh - 285px)',
    [menuToggle, hasSessions]
  )

  useEffect(() => {
    generic
      .getMaintence('manutencao')
      .then(({ data: { data } }) => {
        validateAppVersion(data.version)

        if (data.valor === 'true') {
          window.location.href = '/manutencao'
        } else {
          handleLocalParams()
          data?.length === 0 && getData()
          getFilters({
            companies: true,
            worlds: true,
            centers: true,
            categoryManagers: true,
            productManagers: true,
            compactCategories: true,
            categories: true,
            inventoryStatus: true,
            providersForDistribution: true,
            abcCurves: true,
            subCategories: true
          })
        }
      })
      .catch(() => {})

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Alertas de Compra">
      <Grid
        w="100vw"
        bg="white"
        h={height}
        templateColumns={!filters ? '100vw' : '260px calc(100vw - 260px)'}
      >
        {filters && (
          <LayoutFilters
            filters={filtersList}
            values={params}
            onChange={handleUpdateParams}
            loading={loading}
            canCancel={loading}
            onFilter={getData}
            onClearAllFilters={clearAllFilters}
          />
        )}
        <Box>
          <LayoutTools
            title={filename}
            filters={filters}
            query={query}
            onSearchChange={setQuery}
            actions={actions}
            toggleFilters={setFilters.toggle}
            isDisabled={loading || data.length === 0}
          />
          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os registros no banco de dados"
            />
          ) : data.length === 0 ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <>
              <Text fontSize={14} p={2}>
                {' '}
                {quantity.total} Registros Encontrados, {quantity.compra}{' '}
                alertas de compras e {quantity.recebimento} alertas de
                recebimentos
              </Text>

              <TableGrid
                id="purchase-alert-table"
                headers={headers}
                data={data}
                query={query}
                height={tableHeight}
                itsSortable={true}
                entity="alert-purchase"
                isPaged
              />
            </>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default PurchaseAlert
